var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"modal-plans","size":"xl","hide-footer":""},on:{"show":_vm.getPlans,"hidden":_vm.getPlans}},[_c('h1',[_vm._v("Meus Planos")]),_c('b-progress',{staticClass:"plans",attrs:{"max":100}},[_c('b-progress-bar',{attrs:{"value":_vm.percentage}})],1),_c('br'),_c('Planos',{attrs:{"plans":_vm.plans}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }